'use strict';

var _extends = Object.assign || function (target) {
var arguments$1 = arguments;
 for (var i = 1; i < arguments.length; i++) { var source = arguments$1[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Dropzone = require('dropzone');
Dropzone.autoDiscover = false;

function bodyDragClasses() {

	document.addEventListener('dragover', function () {
		$('body').addClass('dragging');
	});

	document.addEventListener('dragend', function () {
		$('body').removeClass('dragging');
	});
}

$(document).ready(function () {

	/**
  * Image upload scripts
  */
	if ($('.directory-editbrand, .directory-editstore, .settings-profile').length) {

		var brandDropzone = new Dropzone('.image-upload .img', {
			url: '/ajax/image',
			acceptedFiles: '.jpg,.jpeg,.png,.gif',
			params: _extends({ _token: CSRF_TOKEN }, MODEL_DATA)
		});

		brandDropzone.on('thumbnail', function (self, src) {
			$('.img-holder').css('background-image', 'url(' + src + ')');
			$('.img-holder').addClass('has-img uploading');
		});

		brandDropzone.on('success', function () {
			$('.img-holder').removeClass('uploading');
		});

		brandDropzone.on('error', function (self, msg) {
			console.log(msg);
			$('.img-holder .img').addClass('dz-error');
		});

		$('.image-upload .ix.upload').click(function () {
			$('.image-upload .img').click();
		});

		bodyDragClasses();
	}

	/**
  * Order files
  */
	if ($('.data-orders section.files').length) {

		console.log('dropzone init');

		var filesDropzone = new Dropzone('.order-file-dropzone', {
			url: '/ajax/file',
			createImageThumbnails: false,
			params: {
				_token: CSRF_TOKEN,
				order_id: ORDER_ID
			}
		});

		filesDropzone.on('sending', function () {

			$('.order-file-dropzone .dropzone-title').html('<i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Uploading...');
		});

		filesDropzone.on('uploadprogress', function (file, progress, bytesSent) {
			// console.log('progress:', progress, bytesSent);
			// $('.order-file-dropzone .progressbar-line').css('width', (progress/100) + 'px');
		});

		filesDropzone.on('success', function () {
			console.log('success');
			$('.order-file-dropzone .dropzone-title').html('<i class="fa fa-check" aria-hidden="true"></i> Upload Successful.');
		});

		filesDropzone.on('error', function (file, message) {
			$('.order-file-dropzone .dropzone-title').html('<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Error Uploading!');
		});

		bodyDragClasses();
		// setFileDropzoneHeight();
	}
});

function setFileDropzoneHeight() {
	var height = $('.order-file-dropzone').outerHeight();
	$('.order-file-dropzone').css('height', height);
	console.log('height is', height);
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/dropzones.js
// module id = 525
// module chunks = 0